import { FeeCode } from "utils/fees";
import { baseTheme } from "./common";

const colors = {
  primary: "#2E3191",
  secondary: "#D2DFFF",
  tertiary: "#ECF0F8",
  danger: "#F44738",
  warning: "#E0BD2D",
  success: "#62D46B",
  grayScale: {
    lightest: "#FFFFFF",
    light: "#F5F5F5",
    dark: "#9F9F9F",
    darker: "#666666",
    darkest: "#000000",
  },
};

const feeColors: Record<FeeCode, string> = {
  blue: "#3555CC",
  green: colors.success,
  yellow: colors.warning,
  red: colors.danger,
  orange: "#e64d00",
  brown: "#5b1e00",
  pink: "#4c00aa",
  white: "#5E5D5D",
};

const lightTheme = {
  ...baseTheme,
  colors: {
    ...colors,
    background: {
      primary: colors.grayScale.lightest,
      secondary: colors.tertiary,
      tertiary: colors.secondary,
      quaternary: colors.primary,
    },
    text: {
      primary: colors.primary,
      secondary: colors.grayScale.darkest,
      tertiary: colors.grayScale.lightest,
      danger: colors.danger,
    },
    button: {
      primary: {
        background: colors.primary,
        content: colors.grayScale.lightest,
      },
      success: {
        background: colors.success,
        content: colors.grayScale.lightest,
      },
    },
    input: {
      primary: {
        border: colors.grayScale.darker,
        content: colors.grayScale.darkest,
        placeholder: colors.grayScale.darker,
      },
    },
    menu: {
      icon: colors.primary,
      menuIcon: colors.primary,
      closedMenuIcon: colors.grayScale.lightest,
      arrow: colors.primary,
      disabledArrow: colors.grayScale.dark,
      selectedBorder: colors.primary,
      background: colors.grayScale.lightest,
    },
    cardsList: {
      primary: {
        background: colors.grayScale.lightest,
        hover: colors.grayScale.light,
      },
    },
    accordion: {
      primary: {
        border: colors.primary,
        arrowColor: colors.grayScale.darker,
        hiddenInfo: {
          background: colors.grayScale.lightest,
        },
      },
    },
    buttonGroup: {
      active: {
        background: colors.primary,
        text: colors.grayScale.lightest,
        icon: colors.grayScale.lightest,
      },
      inactive: {
        background: "transparent",
        text: colors.primary,
        icon: colors.primary,
      },
    },
    fee: feeColors,
    table: {
      border: colors.grayScale.darkest,
    },
  },
};

export default lightTheme;

export type Theme = typeof lightTheme;
